import React, { useState } from 'react';
import { RedirectionButton } from './components/Button';
import { CommonComponent, CommonComponentContent } from './components/CommonComponent';
import { Container } from './components/Container';
import { Modal } from './components/Modal';
import { Paragraph } from './components/Paragraph';

export interface ProgrammeItem {
  title: string,
  slug: string,
  content: Array<CommonComponentContent>,
}

export interface ProgrammeContentProps {
  title: string,
  text: string,
  background: string,
  programmeItems: Array<ProgrammeItem>
  pathname: string,
}

export interface ProgrammPointProps {
  item: ProgrammeItem,
  background: string,
}

const ProgrammPoint: React.FC<ProgrammPointProps> = ({ item, background }) => (
  <Container>
    <h2 style={{
      maxWidth: 700,
      margin: '0 auto',
    }}
    >
      {item.title}
    </h2>
    {item.content?.map((content: CommonComponentContent, index: number) => (
      <CommonComponent {...content} key={index} />
    ))}
  </Container>
);

const MainContent: React.FC<ProgrammeContentProps> = (props) => {
  const pathArr = props.pathname.split('/');
  const slug = pathArr.at(-1);
  const pickedPoint = props.programmeItems.find((item) => item.slug === slug);
  if (pickedPoint) {
    return <ProgrammPoint item={pickedPoint} background={props.background} />;
  }

  return (
    <Container>
      <div className="programme__text">
        <Paragraph text={props.text} />
      </div>
    </Container>
  );
};
export const ProgrammeContent: React.FC<ProgrammeContentProps> = (props) => (
  <main className="programme">
    <div
      className="programme__top_unit"
      style={{ backgroundImage: `url(${props.background})` }}
    >
      <div className="programme__nav_title_container">
        <div className="programme__navigation">
          <RedirectionButton
            url="/filary"
            color="#FAFAFA"
            text="Filary naszej polityki"
          />
        </div>
        <h1 className="programme__title">{props.title}</h1>
      </div>
    </div>
    <MainContent {...props} />
    <div className="programme__items-container">
      <div className="programme__items-wrapper">
        <div className="programme__items">
          {
            props.programmeItems.map((p: ProgrammeItem, index: number) => (
              <a
                key={index}
                className="programme__item"
                href={`/deklaracja-programowa/${p.slug}`}
              >
                <div className="programme__item__number">
                  {index + 1}
                </div>
                <div className="programme__item__title">
                  {p.title}
                  <div className="programme__item__see-more">
                    ZOBACZ WIĘCEJ
                  </div>
                </div>
              </a>
            ))
          }
        </div>
      </div>
    </div>
  </main>
);
